import Box from '@mui/material/Box';
import React from 'react';
import { SegmentFilter, segmentFilterKey, useSegmentFilters } from '../segmentFilters';
import { DataH5, DataLabel10, WIDGET_COLORS } from './WidgetText';

export interface StatItemProps {
  value: string;
  label: string;
  color?: string;
  // Segments carrying a filter are clickable and toggle themselves in and out
  // of the dashboard's active SegmentFilters. Segments without one - those with
  // no equivalent ransack filter on the passport report - stay plain stats.
  filter?: SegmentFilter;
}

const SegmentItem = ({ value, label, color, filter }: StatItemProps) => {
  const segmentFilters = useSegmentFilters();

  const isClickable = Boolean(filter && segmentFilters);
  const isActive = Boolean(filter && segmentFilters?.activeKeys.has(segmentFilterKey(filter)));
  const accentColor = color || WIDGET_COLORS.gray;

  const handleToggle = () => {
    if (filter && segmentFilters) {
      segmentFilters.toggle(filter);
    }
  };

  return (
    <Box
      onClick={isClickable ? handleToggle : undefined}
      onKeyDown={
        isClickable
          ? (event: React.KeyboardEvent) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleToggle();
              }
            }
          : undefined
      }
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      aria-pressed={isClickable ? isActive : undefined}
      sx={{
        flex: 1,
        marginTop: '8px',
        padding: '4px 4px',
        borderRadius: '4px',
        border: `1px solid ${isActive ? accentColor : 'transparent'}`,
        backgroundColor: isActive ? '#F5F5F5' : 'transparent',
        cursor: isClickable ? 'pointer' : 'default',
        '&:hover': {
          backgroundColor: isClickable && !isActive ? '#FAFAFA' : undefined
        }
      }}
    >
      <DataH5 color={accentColor} inline={false}>
        {value}
      </DataH5>
      <DataLabel10>{label}</DataLabel10>
    </Box>
  );
};

export default SegmentItem;
